import gql from 'graphql-tag';

const query = gql`
  query EventsExport($fromDate: OrdinalDate!, $toDate: OrdinalDate!, $allUsers: Boolean) {
    viewer {
      id
      enabledFeatures
      repVisitsEvents(fromDate: $fromDate, toDate: $toDate, allUsers: $allUsers) {
        id
        collegeFairId
        appointmentId
        date
        startISOTime
        endISOTime
        userBookingStatus
        notes
        staff
        chosenVisitLocationType
        visitUrl
        highSchool {
          id
          name
          address {
            field_hs_elna_timezone
            field_hs_elna_address_line1
            field_hs_elna_city
            field_hs_elna_state_latest
            field_hs_eln_zip
          }
          repVisitsAccount {
            id
            primaryContactPhone
            primaryContact {
              id
              name
              field_job_position
              field_contact_work
            }
            collegeFairsPrimaryContact {
              id
              name
              field_job_position
              field_contact_work
            }
            collegeFairsPrimaryContactPhone
          }
        }
      }
    }
  }
`;

export default query;
